import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { useStatementRejection } from '../../context/statement-rejection';
import styles from './StatementRejectionDialog.style';

const StatementRejectionDialog = ({ onDismiss, onSubmit, className, ...other }) => {
  const { message, setRejectionMessage } = useStatementRejection();
  const [validationMessage, setValidationMessage] = useState();

  const handleInputChange = e => {
    setValidationMessage('');
    setRejectionMessage(e.target.value);
  };

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: 'Reject Statement',
        closeButtonAriaLabel: 'Close',
        // subText: 'Provide a reason for rejecting the statement.',
      }}
      modalProps={{
        className: clsx(styles.root, className),
      }}
      onDismiss={onDismiss}
      onSubmit={onSubmit}
      {...other}
    >
      <div className={styles.instructions}>
        <Text>Fields marked in * are mandatory</Text>
      </div>
      <TextField
        name="message"
        label="Why are you rejecting this statement?"
        multiline
        resizable={false}
        value={message}
        onChange={handleInputChange}
        required
        errorMessage={validationMessage}
      />

      <DialogFooter>
        <DefaultButton
          onClick={() => {
            setValidationMessage('');
            onDismiss();
          }}
        >
          Cancel
        </DefaultButton>
        <PrimaryButton
          type="submit"
          onClick={() => {
            if (message === '') {
              setValidationMessage('Required');
              return;
            }
            onSubmit();
          }}
        >
          Reject
        </PrimaryButton>
      </DialogFooter>
    </Dialog>
  );
};

StatementRejectionDialog.propTypes = {
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
};

StatementRejectionDialog.defaultProps = {
  className: 'normal',
  onDismiss: null,
  onSubmit: null,
};

export default StatementRejectionDialog;
